import React, { useEffect, useLayoutEffect, useState } from "react";
import SearchField from "src/components/SearchField";
import SearchMaskField from "src/components/SearchMaskField";
import SearchSelect from "src/components/SearchSelect";
import useAuth from "src/hooks/useAuth";
import enRoles from "src/models/enums/enRoles";
import { IBuilding } from "src/models/interfaces/building";
import { IPaginationParams } from "src/models/interfaces/pagination";
import { enStatus } from "src/models/interfaces/reservation";
import buildingService from "src/service/building";
import placeService from "src/service/place";
import { Container } from "./styles";

interface IProps {
  params: IPaginationParams;
  mergeParams: (newParams: Partial<IPaginationParams>) => void;
}

const Filters = ({ params, mergeParams }: IProps) => {
  const { user } = useAuth();

  const [countries, setCountries] = useState<string[]>([]);
  const [states, setStates] = useState<string[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [buildings, setBuildings] = useState<IBuilding[]>([]);
  const [floors, setFloors] = useState<string[]>([]);
  const [sections, setSections] = useState<string[]>([]);

  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [selectedState, setSelectedState] = useState<any>(null);
  const [selectedBuilding, setSelectedBuilding] = useState<any>(null);

  useEffect(() => {
    buildingService.getCountry().then(({ data }) => setCountries(data));
    buildingService.get().then(({ data }) => setBuildings(data));
  }, []);

  useEffect(() => {
    setSelectedCountry(params['country']);
    setSelectedState(params['state']);
    setSelectedBuilding(params['building']);
  }, [params]);

  useEffect(() => {
    if (selectedCountry) buildingService.getState(selectedCountry).then(({ data }) => setStates(data));
    else setStates([]);

    setCities([]);
  }, [selectedCountry]);

  useLayoutEffect(() => {
    if (selectedState) buildingService.getCity(selectedState).then(({ data }) => setCities(data));
    else setCities([]);
  }, [selectedState]);

  useEffect(() => {
    if (selectedBuilding && !isNaN(selectedBuilding)) {
      placeService.getByBuildingId(selectedBuilding).then(({ data }) => {
        let uniqueFloor = data
          .map(f => f.floor)
          .filter((value, index, array) => array.indexOf(value) === index)
          .sort((a, b) => a > b ? 1 : -1);
        setFloors(uniqueFloor);

        let uniqueSection = data
          .map(f => f.section)
          .filter((value, index, array) => array.indexOf(value) === index)
          .sort((a, b) => a > b ? 1 : -1);
        setSections(uniqueSection);
      });
    }
    else {
      setFloors([]);
      setSections([]);
    }
  }, [selectedBuilding]);

  return (
    <Container>
      <SearchField
        placeholder='Digite ao menos 3 caracteres...'
        label="Pesquisar"
        width="250px"
        paginationParams={params}
        onChange={mergeParams} />
      {user && [enRoles.sysAdmin, enRoles.doctor].includes(user.roles) &&
        <SearchSelect
          field="pem"
          label="Procurar Equipe Médica?"
          onChange={mergeParams}
          width="140px"
          options={[
            { label: 'Sim', value: 'true' },
            { label: 'Não', value: 'false' }
          ]} />
      }
      <SearchSelect
        field="country"
        label="País"
        onChange={mergeParams}
        options={countries?.map(b => { return { label: b, value: b } })}
        dependent={['state', 'city']} />
      <SearchSelect
        field="state"
        label="Estado"
        onChange={mergeParams}
        options={states?.map(b => { return { label: b, value: b } })}
        dependent={['city']} />
      <SearchSelect
        field="city"
        label="Cidade"
        onChange={mergeParams}
        options={cities?.map(b => { return { label: b, value: b } })} />
      <SearchSelect
        field="building"
        label="Prédio"
        onChange={mergeParams}
        options={buildings?.map(b => { return { label: b.title, value: b.id.toString() } })}
        dependent={['floor', 'section']} />
      <SearchSelect
        field="floor"
        label="Andar / Piso"
        minWidth="100px"
        onChange={mergeParams}
        options={floors?.map(p => { return { label: p, value: p } })} />
      <SearchSelect
        field="section"
        label="Setor"
        minWidth="100px"
        onChange={mergeParams}
        options={sections?.map(p => { return { label: p, value: p } })} />
      <SearchSelect
        field="status"
        label="Status"
        onChange={mergeParams}
        options={Object.keys(enStatus).map(k => { return { label: enStatus[k], value: k } })} />
      <SearchMaskField
        field="iniDate"
        label="Data Início"
        width="110px"
        paginationParams={params}
        type="date"
        onChange={mergeParams} />
      <SearchMaskField
        field="endDate"
        label="Data Fim"
        width="110px"
        paginationParams={params}
        type="date"
        onChange={mergeParams} />
    </Container>
  );
}

export default Filters;